<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        ref="form"
        :form="form"
        :label-col="{ span: 12 }"
        :wrapper-col="{ span: 12 }"
    >
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="问题名称"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-input v-decorator="['questionName',rules.questionName]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-item label="问题分组">
            <a-tree-select
                v-decorator="['questionTypeId',rules.questionTypeId]"
                allow-clear
                :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
                :treeData="treeData"
                :replaceFields="{children:'children', title:'questionTypeName', key:'questionTypeId', value: 'questionTypeId' }"
            >
            </a-tree-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="16">
          <a-form-item label="关键词" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-select
                v-decorator="['keyWords']"
                mode="multiple"
                :options="tagOptions">
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-button type="link" @click="addTag">新增</a-button>
          <a-button type="link" @click="refreshTag">刷新</a-button>
        </a-col>
      </a-row>
      <div v-for="(item,index) in answerList" :key="index">
        <a-row :gutter="24">
          <a-col>
            <div style="color: #ff0000;line-height: 30px;padding-left: 11%;">
              答案{{ index + 1 }}:（仅可选择一类消息类型，若切换则已填写内容会被清空）
              <a-icon type="minus-circle" style="float: right;cursor: pointer;font-size: 18px"
                      @click="delAnswer(index)"/>
            </div>
            <a-form-item label="消息类型"
                         :label-col="{ span: 4 }"
                         :wrapper-col="{ span: 20 }">
              <a-radio-group button-style="solid" v-model="item.typeId">
                <a-radio-button :value="1">文本</a-radio-button>
                <a-radio-button :value="2">图片</a-radio-button>
                <a-radio-button :value="3">文件</a-radio-button>
                <a-radio-button :value="4">链接</a-radio-button>
<!--                <a-radio-button :value="5">H5页面</a-radio-button>-->
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <template v-if="item.typeId === 1">
            <a-form-item label="答案内容"
                         :label-col="{ span: 4 }"
                         :wrapper-col="{ span: 20 }">
              <a-textarea v-model="item.text"/>
            </a-form-item>
          </template>
          <template v-if="item.typeId === 2">
            <a-form-item label="图片设置"
                         :label-col="{ span: 4 }"
                         :wrapper-col="{ span: 20 }">
              <uploader :num="1" v-model="item.picUrl" :accept="'.jpg,.png'"
                        :url="api.temp.UPLOAD_TALK"></uploader>
            </a-form-item>
            <span style="color: #f00;margin-left: 16.66666666666666666%">建议格式：png,jpg，最大为10MB，最多9张</span>
          </template>
          <template v-if="item.typeId === 3">
            <a-form-item label="文件设置"
                         :label-col="{ span: 4 }"
                         :wrapper-col="{ span: 20 }">
              <uploader :num="1" v-model="item.fileUrl" :accept="'*'"
                        :url="api.temp.UPLOAD_TALK"></uploader>
            </a-form-item>
            <span style="color: #f00;margin-left: 16.66666666666666666%">最大为20MB，最多1个</span>
          </template>
          <template v-if="item.typeId === 4">
            <a-form-item label="网页标题"
                         :label-col="{ span: 4 }"
                         :wrapper-col="{ span: 20 }">
              <a-input v-model="item.linkName"/>
            </a-form-item>
            <a-form-item label="网页链接"
                         :label-col="{ span: 4 }"
                         :wrapper-col="{ span: 20 }">
              <a-input v-model="item.linkUrl"/>
            </a-form-item>
          </template>
          <template v-if="item.typeId === 5">
            待开发
          </template>
        </a-row>
      </div>
      <div style="padding-left: 11%;color: #ff0000;" @click="addAnswer">
        <a-icon type="plus-circle"/>
        添加答案
      </div>
    </a-form>

    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save(false)">保存</a-button>
    </a-space>
    <a-modal
        title="新增关键词"
        :closable="true"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        @cancel="closeEdit"
        :width="600"
    >
      <detailForm :rowId="0"
                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </detailForm>
    </a-modal>
  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";
//通用代码api
import {loadBaseCodeData} from '@/services/baseCodeSource';

console.log(loadBaseCodeData)

//接口API
import {dataApi} from '@/services/question/question';
import detailForm from './detail/keyWords';

import {mapState} from "vuex";
import XEUtils from "xe-utils";

/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    questionName: {
      rules: [{required: true, message: "请输入问题标题"}],
    },
    questionTypeId: {
      rules: [{required: true, message: "请选择问题分组"}],
    }
  };
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad() {
  //给子表赋值
}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    questionTypeId: this.questionTypeId,
  }
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  this.answerList = entity.data.answerList
  entity.data.keyWords = entity.data.keyWordsList
  return fmt.formatFormLoad(entity);
}


/**
 * 加载基础数据
 */
async function loadBaseData() {
  let menuData = await dataApi.getQuestionTree();
  // 新增分类禁用 仅最后一级可选
  menuData.data.forEach(item=>{
    item.disabled = true
  })
  let treeData = XEUtils.toArrayTree(menuData.data, {
    key: 'questionTypeId',
    parentKey: 'parentId',
    children: 'children'
  });
  // 新增分类禁用 仅最后一级可选
  treeData.forEach(item=>{
    if(item.children.length){
      item.children.forEach(e=>{
        if(e.children.length){
          e.children.forEach(x=>{
            x.disabled = false
          })
        }
      })
    }
  })

  this.treeData = treeData;

  let keyData = await dataApi.getKeyWords();

  this.tagOptions = keyData.data.map(item => {
    return {
      title: item.keyWordsName,
      key: item.keyWordsId
    }
  })
}

/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  //其他数据处理 类似子表放在这里
  console.log(entities)
  if (entities.keyWords !== '') {
    entities.keyWordsList = entities.keyWords.split(',')
  }
  vm.answerList.forEach((item, index) => {
    console.log(item)
    if (!item.text && !item.fileUrl && (!item.linkName || !item.linkUrl) && !item.picUrl) {
      throw `请填写答案${index + 1}的内容`;
    }
  })
  entities.answerList = vm.answerList
  entities.questionId = vm.keyId
  await dataApi.saveFormDetail(entities);
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {
    detailForm
  },
  props: ['questionTypeId'],
  computed: {
    ...mapState('account', {currUser: 'user'}),
  },
  data() {
    return {
      treeData: [],
      tagOptions: [],
      editModalVisible: false,
      answerList: [{picUrl: '', fileUrl: '', linkName: '', linkUrl: '', text: '', typeId: 1}]
    }
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    loadBaseData,
    afterLoad,
    async refreshTag() {
      let keyData = await dataApi.getKeyWords();

      this.tagOptions = keyData.data.map(item => {
        return {
          title: item.keyWordsName,
          key: item.keyWordsId
        }
      })

      this.$message.success('关键词刷新成功')
    },
    addTag() {
      this.editModalVisible = true
    },
    closeEdit() {
      this.editModalVisible = false
    },
    addAnswer() {
      this.answerList.push({picUrl: '', fileUrl: '', linkName: '', linkUrl: '', text: '', typeId: 1})
    },
    delAnswer(index) {
      if (this.answerList.length <= 1) {
        this.$message.error('已经是最后一条答案了')
        return false
      }
      this.answerList.splice(index, 1)
    }
  },
};
</script>

<style scoped lang="less">
</style>
